import { NgModule } from "@angular/core";
import { SelectModule } from "ng2-select-compat";
import { SharedModule } from "../../shared.module";
import { DynamicFieldDirective } from "./components/dynamic-field/dynamic-field.directive";
import { DynamicFormComponent } from "./dynamic-form/dynamic-form.component";
import { FormButtonComponent } from "./components/form-button.component";
import { FormInputComponent } from "./components/form-input.component";
import { FormSelectComponent } from "./components/form-select.component";
import { FormSelectMultipleComponent } from "./components/form-select-multiple.component";
import { FormCheckboxComponent } from "./components/form-checkbox.component";
import { FormTextareaComponent } from "./components/form-textarea.component";
import { FormDateComponent } from "./components/form-date.component";
import { FormObjectComponent } from "./components/form-object.component";
import { FormListComponent } from "./components/form-list.component";
import { FormHiddenComponent } from "./components/form-hidden.component";
import { FormPasswordComponent } from "./components/form-password.component";
import { FormErrorComponent } from "./components/form-error.component";
import { FormDualListBoxComponent } from "./components/form-dual-list-box.component";
import { DualListboxModule } from "../dual-list-box/dual-list-box.module";
import { MyCheckModule } from "../my-check/my-check.module";
import { FormFileUploadComponent } from "./components/form-file-upload/form-file-upload.component";
import { MultiselectModule } from "../multiselect/multiselect.module";
import { FormSelectMultipleCheckComponent } from "./components/form-select-multiple-check.component";
import {
	OwlDateTimeIntl,
	OwlDateTimeModule,
	OwlNativeDateTimeModule,
} from "ng-pick-datetime";
import { TagsInputModule } from "../tags-input/tags-input.module";
import { UsersService } from "../../services";
import { FormLineComponent } from "./components/form-line.component";
import { FormProfileimageUploadComponent } from "./components/form-profileimage-upload/form-profileimage-upload.component";
import { FormEditorComponent } from "./components/form-editor/form-editor.component";
import { FormArrayComponent } from "./components/form-array.component";
import { FormInputSearchComponent } from "./components/form-input_search.component";
import { FormGoogleMapComponent } from "./components/form-googlemap.component";
import { GermanIntl } from "./models/datetime.german";
import { FormFormbuilderComponent } from "./components/form-formbuilder/form-formbuilder.component";
import { FormLeadexportComponent } from "./components/form-leadexport/form-leadexport.component";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { FormCampaignmanagementComponent } from "./components/form-campaignmanagement/form-campaignmanagement.component";
import { FormNewslettercontentsComponent } from "./components/form-newslettercontents/form-newslettercontents.component";
import { FormUsermanagementComponent } from "./components/form-usermanagement/form-usermanagement.component";
import { FormUserimporttoolComponent } from "./components/form-userimporttool/form-userimporttool.component";
import { FormInlineiframeComponent } from "./components/form-inlineiframe/form-inlineiframe.component";
import { FormEditorialClientComponent } from "./components/form-editorial-client/form-editorial-client.component";
import { FormDatatableComponent } from "./components/form-datatable/form-datatable.component";
import { FormTimepickerComponent } from "./components/form-timepicker/form-timepicker.component";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { FormLeadqualificationComponent } from "./components/form-leadqualification/form-leadqualification.component";
import { FormLinksComponent } from "./components/form-links/form-links.component";
import { FormBlacklistComponent } from "./components/form-blacklist/form-blacklist.component";
import { FormGallerybuilderComponent } from "./components/form-gallerybuilder/form-gallerybuilder.component";
import {FormWarningComponent} from "./components/form-warning.component";

@NgModule({
	imports: [
		SelectModule,
		SharedModule,
		DualListboxModule,
		MyCheckModule,
		MultiselectModule,
		OwlDateTimeModule,
		OwlNativeDateTimeModule,
		TagsInputModule,
		BsDropdownModule.forRoot(),
		NgxMaterialTimepickerModule,
	],
	declarations: [
		DynamicFieldDirective,
		DynamicFormComponent,
		FormButtonComponent,
		FormInputComponent,
		FormInputSearchComponent,
		FormHiddenComponent,
		FormPasswordComponent,
		FormSelectComponent,
		FormSelectMultipleComponent,
		FormCheckboxComponent,
		FormTextareaComponent,
		FormDateComponent,
		FormObjectComponent,
		FormListComponent,
		FormErrorComponent,
		FormDualListBoxComponent,
		FormFileUploadComponent,
		FormProfileimageUploadComponent,
		FormSelectMultipleCheckComponent,
		FormLineComponent,
		FormEditorComponent,
		FormArrayComponent,
		FormGoogleMapComponent,
		FormFormbuilderComponent,
		FormLeadexportComponent,
		FormCampaignmanagementComponent,
		FormNewslettercontentsComponent,
		FormUsermanagementComponent,
		FormUserimporttoolComponent,
		FormInlineiframeComponent,
		FormEditorialClientComponent,
		FormDatatableComponent,
		FormTimepickerComponent,
		FormLeadqualificationComponent,
		FormLinksComponent,
		FormBlacklistComponent,
		FormGallerybuilderComponent,
		FormWarningComponent
	],
	exports: [DynamicFormComponent],
	entryComponents: [
		FormButtonComponent,
		FormInputComponent,
		FormInputSearchComponent,
		FormHiddenComponent,
		FormPasswordComponent,
		FormSelectComponent,
		FormSelectMultipleComponent,
		FormCheckboxComponent,
		FormTextareaComponent,
		FormDateComponent,
		FormObjectComponent,
		FormListComponent,
		FormDualListBoxComponent,
		FormFileUploadComponent,
		FormProfileimageUploadComponent,
		FormSelectMultipleCheckComponent,
		FormLineComponent,
		FormEditorComponent,
		FormArrayComponent,
		FormGoogleMapComponent,
		FormFormbuilderComponent,
		FormLeadexportComponent,
		FormCampaignmanagementComponent,
		FormNewslettercontentsComponent,
		FormUsermanagementComponent,
		FormUserimporttoolComponent,
		FormEditorialClientComponent,
		FormDatatableComponent,
		FormTimepickerComponent,
		FormLeadqualificationComponent,
		FormLinksComponent,
		FormBlacklistComponent,
		FormGallerybuilderComponent,
	],
	providers: [
		UsersService,
		{ provide: OwlDateTimeIntl, useClass: GermanIntl },
	],
})
export class DynamicFormModule {} // end class DynamicFormModule
